export const getMedalsPath = (key: string) => `medals/${key}` as const;
